import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material';
import { TableInterface } from 'src/app/models/interface/table/tableInterface';
import { TechnicalSubprocessObject } from 'src/app/models/orders/order-details-process/process-details/technical-subprocess-object.model';
import { TaskOperationDto } from 'src/app/models/tasks/task-operation/task-operation-dto';


@Component({
  selector: 'app-listing-table',
  templateUrl: './listing-table.component.html',
  styleUrls: ['./listing-table.component.scss']
})
export class ListingTableComponent implements OnInit {

  @Input() dataSource: MatTableDataSource<TaskOperationDto | TechnicalSubprocessObject>;
  @Input() columnsToDisplay: string[];
  @Input() columnsObj: TableInterface[];

  @Output() onClick: EventEmitter<any> = new EventEmitter<TaskOperationDto | TechnicalSubprocessObject>();

  constructor() {}

  ngOnInit() {
  }

}
